import {Link} from 'react-router-dom';

import {Button} from '@/components';
import {Input} from '@/components/common/Input';
import {appPaths} from '@/config/appPaths';

import type {ForgotPasswordFormProps} from './useForgotPassword';

const ForgotPasswordForm = ({
  isLoading,
  handleSubmit,
  handleChange,
}: ForgotPasswordFormProps) => (
  <div className="min-h-screen w-full dark:bg-dark-background flex justify-center items-center px-4">
    <div className="w-full sm:w-4/5 md:w-3/5 lg:w-2/5 flex flex-col justify-center items-center border rounded-md py-7 px-4 dark:border-dark-navBorder">
      <h1 className="text-center text-gray-700 dark:text-gray-100 font-semibold text-xl">
        Reset your password
      </h1>
      <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-2">
        Enter your admin email and we will send you a verification code.
      </p>

      <div className="flex flex-col justify-center items-center w-full my-5 p-2 sm:p-5">
        <form
          className="w-full sm:w-3/5 flex flex-col space-y-10"
          onSubmit={handleSubmit}
          data-cy="admin-forgot-password-form"
        >
          <Input
            onChange={handleChange}
            label="Email"
            type="email"
            name="email"
            required
            className="w-full dark:text-gray-200"
          />

          <Button
            variant="solid"
            colorScheme="cyan"
            type="submit"
            isLoading={isLoading}
            loadingText="Sending..."
          >
            Send code
          </Button>

          <Link
            to={`/${appPaths.login}`}
            className="text-sm text-center text-cyan-600 hover:underline dark:text-cyan-400"
          >
            Back to login
          </Link>
        </form>
      </div>
    </div>
  </div>
);

export default ForgotPasswordForm;
